import { Stack } from "@mui/material";
import { useState } from "react";
import type { EditSolutionFormValues } from "../../../edit/form/types";
import EarthlySectionEditModal from "../common/EditSectionModal/earthly-tsb";
import type { EarthlySectionId, TabProps } from "../types";
import Benefits from "./sections/Benefits";
import CommercialInformation from "./sections/CommercialInformation";
import KeyInformation from "./sections/KeyInformation";
import MapInformation from "./sections/MapInformation";
import ProjectInformation from "./sections/ProjectInformation";
import Publishing from "./sections/Publishing";
import Scores from "./sections/Scores";
import ProjectNarratives from "./sections/ProjectNarratives";

export const referenceImageTooltip =
  "A reference image acting as example of how this information renders on earthly.org";

function EarthlyWebsiteTab({
  details,
  updateSolution,
  updateLoading = false,
  updateAlert,
}: TabProps) {
  const [editingSection, setEditingSection] = useState<EarthlySectionId | null>(
    null,
  );
  const openSection = (section: EarthlySectionId) => setEditingSection(section);
  const closeSection = () => setEditingSection(null);
  const submitSection = async (values: EditSolutionFormValues) => {
    if (!updateSolution) return false;

    try {
      const result = await updateSolution(values);
      return result?.status === 204;
    } catch {
      return false;
    }
  };

  return (
    <Stack data-testid="earthly-website-tab" direction="column">
      <Publishing details={details} onEdit={openSection} />

      <KeyInformation details={details} onEdit={openSection} />

      <Scores details={details} onEdit={openSection} />

      <CommercialInformation details={details} onEdit={openSection} />

      <ProjectInformation details={details} onEdit={openSection} />

      <Benefits details={details} onEdit={openSection} />

      <MapInformation details={details} onEdit={openSection} />

      <ProjectNarratives details={details} onEdit={openSection} />

      <EarthlySectionEditModal
        section={editingSection}
        details={details}
        loading={updateLoading}
        error={updateAlert?.type === "error" ? updateAlert.message : undefined}
        onClose={closeSection}
        onSubmit={submitSection}
      />
    </Stack>
  );
}

export default EarthlyWebsiteTab;
